import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router'
import { SCREEN } from '../../common/selectCurrencyUnit/constant'
import {
  changeAllowSetDefaultUnit,
  selectAllowSetDefaultUnit,
} from '../../common/selectCurrencyUnit/slice'
import { selectUserType } from '../../layout/store/slice'
import { COMPONENTS } from '../../routers/constants'
import { Layout } from '../Layout'
import { CompanyInfo } from '../common/header/companyInfo'
import { selectCompanyInfo } from '../common/header/companyInfo/store/slice'
import { resetFullStoreDetailTemplate } from '../common/preferenceSetting/detailTemplate/store/slice'
import { Highlight } from './highlight'
import './lang/i18n'
import { Panels } from './panels'
import PreferenceSetting from './preferenceSetting'
import { StickyBar } from './stickyBar'
import { selectLoading, selectPanelId } from './store/slice'
import { getDefaultTemplateForLayoutThunk } from './store/thunk'
import useCallApi from './useCallApi'

const KEY_ORGANIZATION_ID = 'organizationIdSummary'

const Summary = () => {
  const screen = SCREEN.SUMMARY
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()

  useCallApi()

  const isSomePanelLoading = useSelector(selectLoading())
  const allowSetDefaultUnit = useSelector(selectAllowSetDefaultUnit(screen))
  const companyInfo = useSelector(selectCompanyInfo)
  const userType = useSelector(selectUserType)
  const panelId = useSelector(selectPanelId)

  const { organizationId, preferenceSetting } = new Proxy(
    new URLSearchParams(location.search),
    {
      get: (searchParam, prop) => searchParam.get(prop),
    },
  )

  const setIsShowPreferenceSetting = (payload) => {
    if (payload) {
      dispatch(resetFullStoreDetailTemplate())
    }
    const params = `?organizationId=${organizationId}${
      payload ? '&preferenceSetting=true' : ''
    }&showDetail=true`
    navigate(COMPONENTS.companyAnalysis.components.summary.route + params)
  }

  useEffect(() => {
    if (!isSomePanelLoading) {
      dispatch(
        changeAllowSetDefaultUnit({ screen, allowSetDefaultUnit: false }),
      )
    }
  }, [isSomePanelLoading])

  useEffect(() => {
    const organizationIdStorage = localStorage.getItem(KEY_ORGANIZATION_ID)
    if (companyInfo.organizationId) {
      if (
        !panelId.length ||
        companyInfo.organizationId !== +organizationIdStorage
      ) {
        dispatch(
          getDefaultTemplateForLayoutThunk({
            data: {
              TemplateType: companyInfo.companyType,
            },
            companyType: companyInfo.companyType,
            userTypeId: userType.userTypeId,
          }),
        )
        localStorage.setItem(KEY_ORGANIZATION_ID, companyInfo.organizationId)
      }
    }
  }, [companyInfo])

  const renderTopComponent = () => !preferenceSetting && <CompanyInfo />
  const renderStickyComponent = () =>
    !preferenceSetting && (
      <StickyBar setIsShowPreferenceSetting={setIsShowPreferenceSetting} />
    )
  const renderBottomComponent = () => {
    if (preferenceSetting) {
      return (
        <PreferenceSetting
          setIsShowPreferenceSetting={setIsShowPreferenceSetting}
        />
      )
    }

    return (
      <>
        <Highlight />
        <Panels setIsShowPreferenceSetting={setIsShowPreferenceSetting} />
      </>
    )
  }

  return (
    <Layout
      renderTopComponent={renderTopComponent}
      renderBottomComponent={renderBottomComponent}
      renderStickyComponent={renderStickyComponent}
      isLoadingContent={allowSetDefaultUnit}
      isShowFooter={false}
    />
  )
}

export default Summary
